/**
 * Checks whether a redirect path is a safe internal application route.
 * Only an absolute in-app path is allowed (must start with a single leading slash).
 * Protects against open-redirects to external URLs (e.g. "http://...", "//evil.com", "/\evil.com").
 * @param {String} redirectPath - redirect path from the login (bounce) payload
 * @return {Boolean} true if the path is a valid internal route
 * @example isValidRedirectPath('/ezlo/automation/local'); // true
 * */
export const isValidRedirectPath = (redirectPath) => {
    if (typeof redirectPath !== 'string') {
        return false;
    }

    return /^\/(?![/\\])/.test(redirectPath);
};
